<template>
  <div class="mt-5 col-11 m-5">
    <b-card title="Contact Us">
      <b-card v-for="author in authors" :key="author.name" :title="author.name" style="border:none">
        Email:<a :href="'mailto:'+author.Email">{{author.Email}}</a>
      </b-card>
      <b-card style="border:none">
        <h6>Institute of Antibody Engineering</h6>
        <h6>School of Laboratory Medicine and Biotechnology</h6>
        <h6>Southern Medical University</h6>
        <h6>NO. 1838 Guangzhou Road Guangzhou, Guangdong, China</h6>
      </b-card>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'About',
  data: function () {
    return {
      authors: [
        {
          name: 'Kun Li',
          Email: '751234501@qq.com'
        },
        {
          name: 'Zhiwei Guo',
          Email: 'gzw188@126.com'
        },
        {
          name: 'Tiancai Liu',
          Email: 'liutc@smu.edu.cn'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue